<template>
  <div class="grid grid-cols-2 gap-5">
    <div class="shadow-lg py-5 px-7 flex flex-col justify-between">
      <h4 class="text-xl font-semibold mb-2">Montant fixe par offre</h4>
      <p>Pour chaque offre, indiquez le montant que vous souhaitez rétribuer à vos vendeurs.</p>
      <div class="text-center m-2">
        <GenericButton @click="configSellerFixedPriceModalOpen = true">Configurer un montant fixe</GenericButton>
      </div>
      <Modal size="big" :open="configSellerFixedPriceModalOpen" @close="configSellerFixedPriceModalOpen = false">
        <h4 class="text-xl font-semibold">Rétribution en montant fixe</h4>
        <p>Indiquer le montant de la rétribution par offre et par durée.</p>

        <RetributionTable
          :retributions="retributionConfigurations"
          editable
          @editSellerRetribution="editRetributionConfiguration"
          :hideManagerRetribution="true"
          :hideSellerRetribution="false"
        />
        <div class="mt-4 flex justify-center">
          <GenericButton @onClick="submitEditSellerFixedPrice">Valider la rétribution</GenericButton>
        </div>
      </Modal>
    </div>

    <div class="shadow-lg py-5 px-7 flex flex-col justify-between">
      <h4 class="text-xl font-bold mb-2">Primes en pourcentage</h4>
      <p>Indiquez le montant en pourcentage de votre rémunération que vous souhaitez rétribuer à vos vendeurs.</p>
      <div class="text-center m-2">
        <GenericButton @click="configSellerPercentageModalOpen = true">Configurer un pourcentage</GenericButton>
      </div>
      <Modal :open="configSellerPercentageModalOpen" @close="configSellerPercentageModalOpen = false">
        <h4 class="text-xl font-semibold">Rétribution en pourcentage</h4>
        <p class="mb-4">Indiquez le pourcentage de la rémunération que vous souhaitez rétribuer à vos vendeurs.</p>
        <FormField
          id="percentage_value"
          label="Pourcentage de la rémunération à rétribuer"
          name="percentage_value"
          trailing-add-ons="%"
          required
          v-model="sellerPercentageValue"
        />
        <div class="mt-4 flex justify-center">
          <GenericButton @onClick="submitEditSellerPercentage">Valider la rétribution</GenericButton>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Modal, FormField } from "@estaly/ui";
import GenericButton from "@/components/utils/GenericButton.vue";
import RetributionTable from "@/components/retribution/RetributionTable.vue";
import StoreService from "@/api/services/store.js";

export default {
  name: "SellerRetributionConfiguration",

  components: {
    FormField,
    Modal,
    GenericButton,
    RetributionTable,
  },

  data() {
    return {
      configSellerPercentageModalOpen: false,
      configSellerFixedPriceModalOpen: false,
      sellerPercentageValue: null,
      retributionConfigurationsSellerFixedPriceChanges: {},
    };
  },

  computed: {
    ...mapState("store", ["stores"]),
    ...mapState("retributionConfigurations", ["selectedStoreId", "retributionConfigurations"]),

    store() {
      return this.stores.find((store) => store.id == this.selectedStoreId);
    },
  },

  methods: {
    ...mapActions("retributionConfigurations", ["fetchRetributionConfigurations"]),
    ...mapActions("notifications", ["notify", "clearAll"]),

    async submitEditSellerPercentage() {
      if (!this.sellerPercentageValue) return document.getElementById("percentage_value").focus();

      const response = await StoreService.updateRetributionConfigurationsPercentage(this.store.id, {
        sellerValue: this.sellerPercentageValue / 100,
        sellerPercentage: true,
      });
      if (!response.success) return;

      await this.fetchRetributionConfigurations();
      await this.notify({
        category: "simple",
        type: "success",
        title: "Mise à jour effectuée",
      });
      this.configSellerPercentageModalOpen = false;
    },

    editRetributionConfiguration(retributionConfigurationId, value) {
      this.retributionConfigurationsSellerFixedPriceChanges[retributionConfigurationId] = value;
    },

    async submitEditSellerFixedPrice() {
      this.clearAll();
      const errors = [];

      await Promise.all(
        Object.entries(this.retributionConfigurationsSellerFixedPriceChanges).map(
          async ([retributionConfigurationId, value]) => {
            const response = await StoreService.updateRetributionConfigurationsFixedPrice(
              this.store.id,
              retributionConfigurationId,
              {
                sellerValue: value,
                sellerPercentage: false,
              },
            );
            if (!response.success) errors.push(retributionConfigurationId);
            else {
              this.lowlightError(retributionConfigurationId);
              delete this.retributionConfigurationsSellerFixedPriceChanges[retributionConfigurationId];
            }
          },
        ),
      );

      await this.fetchRetributionConfigurations();

      if (errors.length === 0) {
        await this.notify({
          category: "simple",
          type: "success",
          title: "Mise à jour effectuée",
        });
        this.configSellerFixedPriceModalOpen = false;
      } else {
        console.log("Errors in retribution configurations:", errors);
        errors.forEach((retributionConfigurationId) => {
          this.highlightError(retributionConfigurationId);
        });
      }
    },

    highlightError(retributionConfigurationId) {
      document
        .getElementById(`seller-retribution-${retributionConfigurationId}`)
        .classList.add("border-2", "border-red-500");
    },

    lowlightError(retributionConfigurationId) {
      document
        .getElementById(`seller-retribution-${retributionConfigurationId}`)
        .classList.remove("border-2", "border-red-500");
    },
  },

  watch: {
    async selectedStoreId() {
      if (this.store?.sellerIncentivePercentage)
        this.sellerPercentageValue = this.store.sellerIncentivePercentage * 100;
    },
  },
};
</script>
